import { useMutation } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { useCallback, useEffect, useState } from 'react';

import {
  GetCheckinEntryDetailDocument,
  NotifyCheckinEntryDocument,
} from '~/graphql/generated/graphql';
import { checkinNotifyConfirmModalState } from '~/state/reception/atoms';

export const useNotifyCheckinEntry = () => {
  const [error, setError] = useState('');
  const { checkinEntryId } = useAtomValue(checkinNotifyConfirmModalState);

  const resetState = useResetAtom(checkinNotifyConfirmModalState);
  const [notifyCheckinEntry, { loading: notifying, data }] = useMutation(
    NotifyCheckinEntryDocument,
    {
      refetchQueries: [{ query: GetCheckinEntryDetailDocument, variables: { id: checkinEntryId } }],
    },
  );

  useEffect(() => {
    if (!data) return;
    resetState();
  }, [data, resetState]);

  const notify = useCallback(async () => {
    if (!checkinEntryId) return;

    setError('');

    try {
      await notifyCheckinEntry({
        variables: {
          input: {
            checkinEntryId: checkinEntryId,
          },
        },
      });
    } catch (e) {
      setError(e?.message || 'エラーが発生しました');
    }
  }, [checkinEntryId, notifyCheckinEntry]);

  return { notify, notifying, error };
};
